module.exports = "/fonts/Objectivity-Black.woff2";